import { fg } from '@atlaskit/platform-feature-flags/fg';

import { QueryIntent } from '../../constants';

/**
 * Maps product filter key names to the display string to append to the query.
 * "google_drive" is mapped to "google" per product requirement.
 */
const PRODUCT_DISPLAY_NAME_MAP: Record<string, string> = {
	confluence: 'confluence',
	jira: 'jira',
	github: 'github',
	teams: 'teams',
	drive: 'google',
};

/**
 * Post-processes the query by appending " from [product]" when:
 *  - the feature gate `kd_team_26_sain_rewrite_query` is enabled, AND
 *  - queryIntent is NATURAL_LANGUAGE_QUERY, AND
 *  - selectedProduct is a whitelisted product string
 *
 * Otherwise returns the original query unchanged.
 */
export function rewriteQueryWithProductFilter(
	query: string,
	selectedProduct: string | undefined,
	queryIntent: QueryIntent | undefined,
): string {
	if (!fg('kd_team_26_sain_rewrite_query') || queryIntent !== QueryIntent.NATURAL_LANGUAGE_QUERY) {
		return query;
	}

	if (!selectedProduct || !(selectedProduct in PRODUCT_DISPLAY_NAME_MAP)) {
		return query;
	}

	return `${query} from ${PRODUCT_DISPLAY_NAME_MAP[selectedProduct]}`;
}
